export default {
  gameProviderName: 'Onlyplay',
  baseDomain: 'onlyplay',
  lacalizationDomain: 'onlyplaygames',
  igDomain: 'ig-onlyplay',
  playGameSettings: 'onlyPlayGameSettings' //?
}
